import 'swiper/swiper-bundle.css';
import Vant, { Icon } from 'vant';
import 'vant/lib/index.css';
import 'video.js/dist/video-js.css';
import Vue from 'vue';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import VueCookies from 'vue-cookies';
import VueI18n from 'vue-i18n';
import App from './App.vue';
import common from './common/function';
import http from './http';
import router from './router';
import store from './store';
Vue.prototype.$http = http
Vue.prototype.common = common
Vue.config.productionTip = false
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
Vue.use(Vant);
Vue.use(Icon);
Vue.use(VueI18n);
Vue.use(VueCookies)
const i18n = new VueI18n({
  globalInjection: true, 
  locale: localStorage.getItem("lang") || "en", // 将要切换的语言，可以通过url拼的参数获取，用户行为select选择获取，本地manifest配置获取等，根据场景动态获取
  messages: {
    'zh': require('./assets/languages/zh.json'),
    'en': require('./assets/languages/en.json'),
    'ja': require('./assets/languages/ja.json'),
    'kr': require('./assets/languages/kr.json'),
    'hi': require('./assets/languages/hi.json'),
  }
});
new Vue({
  store,
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')
